import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'

import { withStyles } from '@material-ui/core/styles'
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Paper,
} from '@material-ui/core'

import Link from '../controls/Link'
import UnitStatusContainer from './UnitStatusContainer'
import UnitTimeseriesValueContainer from './UnitTimeseriesValueContainer'

class UnitListView extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    units: PropTypes.array.isRequired,
    history: PropTypes.object.isRequired,
  }

  static styles = (theme) => ({
    paper: theme.mixins.gutters({
      paddingTop: 16,
      paddingBottom: 16,
      marginTop: theme.spacing(3),
    }),
    table: {
      '& a': theme.a,
    },
    clickable: theme.clickable,
  })

  state = { units: this.props.units, order: 'asc' }

  componentDidMount() {
    this.sortUnits()
  }

  componentWillReceiveProps(nextProps) {
    this.setState(
      { units: nextProps.units },
      this.sortUnits,
    )
  }

  onUnitClick = (unit) => {
    this.props.history.push(`/units/${unit.id}`)
  }

  sortUnits = () => {
    this.setState(
      (prevState) => {
        const units = prevState.order === 'desc'
          ? prevState.units.sort((a, b) => (b.name < a.name ? -1 : 1))
          : prevState.units.sort((a, b) => (a.name < b.name ? -1 : 1))

        return { units }
      },
    )
  }

  handleSort = () => {
    this.setState(
      (prevState) => ({
        order: prevState.order === 'desc' ? 'asc' : 'desc',
      }),
      this.sortUnits,
    )
  }

  render() {
    const { classes } = this.props
    const { units, order } = this.state
    return (
      <Paper className={classes.paper} elevation={0}>
        <Typography variant="h6">Units</Typography>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>
                <TableSortLabel active direction={order} onClick={this.handleSort}>
                  Unit
                </TableSortLabel>
              </TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Temperature</TableCell>
              <TableCell>Power Consumption</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              units.map((u) => (
                <TableRow key={u.id} className={classes.clickable} onClick={() => { this.onUnitClick(u) }}>
                  <TableCell><Link to={`/units/${u.id}`}>{u.name}</Link></TableCell>
                  <TableCell><UnitStatusContainer unitId={u.id} /></TableCell>
                  <TableCell><UnitTimeseriesValueContainer unitId={u.id} timeseriesName="temp/indoor" /></TableCell>
                  <TableCell><UnitTimeseriesValueContainer unitId={u.id} timeseriesName="energy/power" /></TableCell>
                </TableRow>
              ))
            }
          </TableBody>
        </Table>
      </Paper>
    )
  }
}

export default withStyles(UnitListView.styles)(withRouter(UnitListView))
